import React, { Component } from "react";
import { connect } from "react-redux";

import MotivationListing from "./motivationListing";
import { reset } from "redux-form";
import { getMotivationList, addNewMotivation, updateMotivation, deleteMotivation } from "../../store/actions";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

class MotivationManagement extends Component {
	componentDidMount() {
		const { history, isAdmin, getMotivationList } = this.props;
		isAdmin === false && history.push("/");

		getMotivationList();
	}

	submitMotivation = (formType, fileType, values, adId) => {
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				this.props.resetForm("AddOrupdateMotivation");
				NotificationManager.success(
					formType === "Add" ? "Motivational content submitted" : "Motivational content updated",
					"",
					5000
				);

				this.props.getMotivationList();
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};

		const errorHandler = (event) => {
			event && event.error_code === "VALIDATION_ERROR" && NotificationManager.error("Invalid Fields", "", 5000);
		};

		if (formType === "Add") {
			this.props.addNewMotivation(values, fileType, successHandler, errorHandler);
		} else if (formType === "Update") {
			this.props.updateMotivation(values, adId, successHandler, errorHandler);
		}
	};

	deleteMotivation = (deleteItem) => {
		const successHandler = (event) => {
			if (event.status >= 200 && event.status < 300) {
				NotificationManager.success("Motivational Content Deleted", "", 5000);
				this.props.getMotivationList();
			} else {
				NotificationManager.error("Please try again!", "", 5000);
			}
		};
		this.props.deleteMotivation(deleteItem, successHandler);
	};

	render() {
		return (
			<MotivationListing
				motivationList={this.props.motivationList}
				getMotivationList={this.props.getMotivationList}
				submitMotivation={this.submitMotivation}
				deleteMotivation={this.deleteMotivation}
			/>
		);
	}
}

const mapStateToProps = (state) => {
	const { MotivationManagement, Auth } = state;
	return {
		motivationList: get(MotivationManagement, "motivation_list", []),
		isAdmin: Auth.isAdmin
	};
};

const mapDispatchToProps = {
	getMotivationList,
	addNewMotivation,
	updateMotivation,
	deleteMotivation,
	resetForm: reset
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(MotivationManagement);
